import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "form-outputs",
  courseId: "forms",
  order: 5,
  title: "Form outputs",
  subtitle: "Fillable, flat, and text",
  summary:
    "A filled form can leave the app as a PDF with live fields, a flattened PDF for records, or text for systems that do not take PDFs.",
  learn: [
    "Pick Fillable PDF or Flat PDF on export",
    "Know when text output is the better choice",
    "Match the output to where the form is going",
  ],
  minutes: 2,
  releasedAt: "2025-06-01T00:00:00.000Z",
  body: [
    {
      type: "paragraph",
      text: "The same filled submission can leave the app in several shapes. Pick the one that matches where it is going. You can always come back and export another.",
    },
    {
      type: "bullets",
      items: [
        "Fillable PDF: fields stay editable in Acrobat or Preview. Use it when a supervisor or another unit will add to the form.",
        "Flat PDF: values are burned into the page. Use it for the records copy and anything leaving the department.",
        "Text output: the template's placeholders filled as plain text, or an AI-written text version (formal, brief, or detailed). Use it for an RMS field that will not accept an attachment.",
      ],
    },
    {
      type: "steps",
      items: [
        "In the Form Editor, click **Export PDF**.",
        "Choose \"Fillable PDF\" or \"Flat PDF\".",
      ],
    },
    {
      type: "paragraph",
      text: "For a text version, use the template's text output option, where the template was set up with one.",
    },
    {
      type: "callout",
      tone: "note",
      text: "The recipient of a flat PDF cannot re-open it for editing, but you can re-export from the submission at any time. The data stays in the app.",
    },
    {
      type: "paragraph",
      text: "To fill a form in the first place, see \"Fill from audio\". \"Export your report\" covers exporting the narrative itself.",
    },
  ],
  related: ["fill-a-form-from-audio", "export-your-report"],
};

export default lesson;
